var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoofBSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 116,
    viewBox: "0 0 98 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4954 17.048V9.97412H81.5137L81.5137 26.9748",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8654 5.40869H82.1602V9.97391H67.8654V5.40869Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7748 44.151V107.968H9.23633V44.1499",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2097 35.2495H37.8008V50.2244H60.2097V35.2495Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1197 71.6904H20.9668V91.8434H41.1197V71.6904Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0436 71.6904H56.8906V91.8434H77.0436V71.6904Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8822 44.1215L49.0063 11.9807L8.93322 44.1396C7.4989 45.2823 4.15541 45.57 2.65353 43.6208C1.10743 41.6141 2.5606 38.4171 3.99492 37.2744L47.7506 2.42708C48.5447 1.79449 49.4689 1.79449 50.263 2.42708L94.0187 37.2744C95.452 38.4171 96.8764 41.5915 95.3601 43.6208C93.8412 45.6533 90.3204 45.2606 88.8822 44.1215Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24004 107.967H88.7754V115H9.24004V107.967Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofBSelected);
export default __webpack_public_path__ + "static/media/roof-b-selected.0681e83fca0e051fdddb1b5d7910934d.svg";
export { ForwardRef as ReactComponent };